<mat-dialog-content style="height: 75vh;">
    <div layout="row" layout-align="center center">
        <div style="margin-bottom: 2%;">
            <strong >{{titulo}}</strong>
        </div>
        <div class="mod-container" style="margin-top: 20px;">
            <table>
                <tr>
                    <td style="width: 30%;">
                        <mat-form-field style="width: 95%;">
                            <input matInput placeholder="Nombre del envio" 
                                [(ngModel)]=nombre>
                        </mat-form-field>
                    </td>
                    <td style="width: 30%;">
                        <p [hidden]="nombreConsorcio!=''" >
                            <input [(ngModel)]=txtConsorcio
                                type="text" size="10"
                                style="border: 1px solid #01a9ac;"
                                (keydown.enter)="buscarConsorcio()"
                                autoComplete="off">
                            <i class="fas fa-search fa-gradient" style="font-size: 1em; cursor: pointer;
                                margin-top: 0px; margin-left: 5px;" (click)="buscarConsorcio()"
                                matTooltip="Buscar consorcio">
                            </i>
                        </p>
                        <p [hidden]="nombreConsorcio==''">
                            <i class="fas fa-trash fa-gradient" style=" margin-right: 5px;
                                font-size: 1em; cursor: pointer; margin-right: 5px;
                                margin-top: 0px;" (click)="eliminarConsorcio()"
                                matTooltip="Eliminar consorcio">
                            </i>
                            {{nombreConsorcio}}
                        </p>
                    </td>
                    <td style="width: 30%;">
                        <p [hidden]="nombreMail!=''" >
                            <input [(ngModel)]=txtMail
                                type="text" size="10"
                                style="border: 1px solid #01a9ac;"
                                (keydown.enter)="buscarMail()"
                                autoComplete="off">
                            <i class="fas fa-search fa-gradient" style="font-size: 1em; cursor: pointer;
                                margin-top: 0px; margin-left: 5px;" (click)="buscarMail()"
                                matTooltip="Buscar mail">
                            </i>
                        </p>
                        <p [hidden]="nombreMail==''">
                            <i class="fas fa-trash fa-gradient" style=" margin-right: 5px;
                                font-size: 1em; cursor: pointer; margin-right: 5px;
                                margin-top: 0px;" (click)="eliminarMail()"
                                matTooltip="Eliminar mail">
                            </i>
                            {{nombreMail}}
                        </p>
                    </td>
                </tr>
            </table>
            
        </div>
        <div [hidden]="pasoActual!='-1' && pasoActual!='00'">
            <div style="margin-bottom: 2%; width: 100%; text-align: center;">
                <strong style="font-size:18px;"><u>{{lblPasoActual}}</u></strong>
            </div>
            <div style="margin-bottom: 2%; width: 100%; text-align: center;">
                <strong style="font-size:14px;">Subir el archivo PDF de la notificación</strong>
            </div>
            <div class="col-8">
                <label class="btn btn-default p-0">
                  <input type="file" multiple (change)="selectFiles($event)" accept="application/pdf"/>
                </label>
            </div>
            
            <div class="col-4" style="margin-bottom: 20px;">
                <button
                  class="btn btn-success btn-sm"
                  [disabled]="!selectedFiles"
                  (click)="uploadFilesPDF()"
                >
                  Subir archivos
                </button>
            </div>
            <div *ngFor="let progressInfo of progressInfos" class="mb-2">
                <span>{{ progressInfo.fileName }}</span>
                <div class="progress">
                  <div
                    class="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    attr.aria-valuenow="{{ progressInfo.value }}"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [ngStyle]="{ width: progressInfo.value + '%' }">
                    {{ progressInfo.value }}%
                  </div>
                </div>
            </div>
            <div *ngIf="message.length" class="alert alert-secondary my-3" role="alert">
                <ul *ngFor="let msg of message; let i = index">
                  <li>{{ msg }}</li>
                </ul>
            </div>
            
            <div *ngIf="pasoActual=='00'">
                <table style="width: 100%; text-align: center;"> 
                    <tr>
                        <td style="width: 40%;"></td>
                        <td style="width: 30%;">
                            <button mat-raised-button class="btn-agregar" (click)="muestraSiguiente01()">
                                Siguiente
                                <i class="fas fa-arrow-circle-right fa-1x" style="width: 20px; margin-left:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                            </button>
                        </td>
                        <td style="width: 40%;"></td>
                    </tr>
                </table>
            </div>
        </div>
        <div [hidden]="pasoActual!='01' && pasoActual!='02'">
            <div style="margin-bottom: 2%; width: 100%; text-align: center;">
                <strong style="font-size:18px;"><u>{{lblPasoActual}}</u></strong>
            </div>
            <div style="margin-bottom: 2%; width: 100%; text-align: center;">
                <strong style="font-size:14px;">Subir el archivo xlsx con las casillas de mails</strong>
            </div>
            <div class="col-8">
                <label class="btn btn-default p-0">
                  <input type="file" multiple (change)="selectFiles($event)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
                </label>
            </div>
            
            <div class="col-4" style="margin-bottom: 20px;">
                <button
                  class="btn btn-success btn-sm"
                  [disabled]="!selectedFiles"
                  (click)="uploadFiles()"
                >
                  Subir archivos
                </button>
            </div>
            <div *ngFor="let progressInfo of progressInfos" class="mb-2">
                <span>{{ progressInfo.fileName }}</span>
                <div class="progress">
                  <div
                    class="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    attr.aria-valuenow="{{ progressInfo.value }}"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [ngStyle]="{ width: progressInfo.value + '%' }">
                    {{ progressInfo.value }}%
                  </div>
                </div>
            </div>
            <div *ngIf="message.length" class="alert alert-secondary my-3" role="alert">
                <ul *ngFor="let msg of message; let i = index">
                  <li>{{ msg }}</li>
                </ul>
            </div>
            
            <div *ngIf="pasoActual=='02'">
                <table style="width: 100%; text-align: center;"> 
                    <tr>
                        <td style="width: 10%;">
                        </td>
                        <td style="width: 30%;">
                            <button mat-raised-button class="btn-agregar" (click)="anteriorPaso02()">
                                <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-left:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                                Anterior
                            </button>
                        </td>
                        <td style="width: 10%;"></td>
                        <td style="width: 30%;">
                            <button mat-raised-button class="btn-agregar" (click)="muestraSiguiente02()">
                                Siguiente
                                <i class="fas fa-arrow-circle-right fa-1x" style="width: 20px; margin-left:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                            </button>
                        </td>
                        <td style="width: 40%;"></td>
                    </tr>
                </table>
            </div>
        </div>
        <div [hidden]="pasoActual!='03'">
            <div style="margin-bottom: 2%; width: 100%; text-align: center;">
                <strong style="font-size:18px;"><u>{{lblPasoActual}}</u></strong>
            </div>
            <div style="margin-bottom: 2%; width: 100%; text-align: left;">
                <strong style="font-size:10px;">Por favor, revise los datos que se subieron y si esta todo bien, pase al siguiente paso</strong>
            </div>
            <table mat-table [dataSource]="dataSourcePaso2" class="mat-elevation-z8" style="width: 100%;">
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                    <td mat-cell *matCellDef="let element">
                        <i *ngIf="element.resultado=='NO'" class="fas fa-times-circle" style="width: 10px; margin-right:5%;
                            font-size: 1.5em; cursor: pointer; color: #c9061a;
                            margin-top: 0px; margin-right: 3vw;"
                            matTooltip="Error al subir el archivo"
                        ></i>
                        <i *ngIf="element.resultado=='SI'" class="fas fa-file-pdf" style="width: 10px; margin-right:5%;
                            font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                            margin-top: 0px; margin-right: 3vw;"
                            matTooltip="Ver PDF"
                        ></i>
                    </td>
                </ng-container>
                <ng-container matColumnDef="mails">
                    <th mat-header-cell *matHeaderCellDef style="width:20%;"> Mails</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.mails}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="msgError">
                    <th mat-header-cell *matHeaderCellDef style="width:20%;"> Error</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.msgError}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>">
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator #paginador [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            <table style="width: 100%; text-align: center;"> 
                <tr>
                    <td style="width: 10%;">
                    </td>
                    <td style="width: 30%;">
                        <button mat-raised-button class="btn-agregar" (click)="anteriorPaso03()">
                            <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-left:10px;
                                font-size: 1.5em; cursor: pointer;"></i>
                            Anterior
                        </button>
                    </td>
                    <td style="width: 10%;"></td>
                    <td style="width: 30%;">
                        <button mat-raised-button class="btn-agregar" (click)="almacenar()">
                            Almacenar
                            <i class="fas fa-save fa-1x" style="width: 20px; margin-left:10px;
                                font-size: 1.5em; cursor: pointer;"></i>
                        </button>
                    </td>
                    <td style="width: 40%;"></td>
                </tr>
            </table>
        </div>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
            </td>
        </tr>
    </table>
</div>

